import { Button, Flex } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { CursorList } from '../lib/use-cursor-list';

/**
 * The "Load more" row under a queue that is not a ListPage (a till card, the
 * warehouse queue). Renders nothing once the last page is in.
 */
export function LoadMore<T>({ list }: { list: CursorList<T> }): ReactNode {
  const { t } = useTranslation();
  if (!list.hasMore) return null;
  return (
    <Flex justify="center" style={{ padding: 12 }}>
      <Button size="large" loading={list.isFetching} onClick={list.loadMore}>
        {t('customers.loadMore')}
      </Button>
    </Flex>
  );
}
